import { log } from "./log.ts";
import { officeReady } from "./office-ready.ts";

const THREAD_SETTING_KEY = "bigpp.activeThreadId";
const LEGACY_LOCAL_THREAD_KEY = "bigpp.activeThreadId";

const clearLegacyLocalThread = (): void => {
  try {
    globalThis.localStorage?.removeItem(LEGACY_LOCAL_THREAD_KEY);
  } catch {
    // best-effort
  }
};

const documentSettings = (): Office.Settings | null => {
  try {
    return Office.context?.document?.settings ?? null;
  } catch {
    return null;
  }
};

const saveSettings = (settings: Office.Settings): Promise<boolean> =>
  new Promise((resolve) => {
    settings.saveAsync((result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        log.warn("deck thread setting save failed", {
          message: result.error?.message ?? "unknown",
        });
        resolve(false);
        return;
      }
      resolve(true);
    });
  });

export const getDeckActiveThreadId = async (): Promise<string | null> => {
  await officeReady;
  clearLegacyLocalThread();
  const settings = documentSettings();
  if (!settings) return null;
  const value = settings.get(THREAD_SETTING_KEY);
  return typeof value === "string" && value.length > 0 ? value : null;
};

export const setDeckActiveThreadId = async (id: string | null): Promise<void> => {
  await officeReady;
  const settings = documentSettings();
  if (!settings) return;
  if (id) settings.set(THREAD_SETTING_KEY, id);
  else settings.remove(THREAD_SETTING_KEY);
  await saveSettings(settings);
};
